export default [
    "20 18",
    '<path d="M2.5 17.9963H17.5C18.8789 17.9963 20 16.8752 20 15.4963V5.49634C20 4.11743 18.8789 2.99634 17.5 2.99634H11.6602C10.9961 2.99634 10.3594 2.73462 9.89062 2.26587L8.85547 1.22681C8.38672 0.758057 7.75 0.496338 7.08594 0.496338H2.5C1.12109 0.496338 0 1.61743 0 2.99634V15.4963C0 16.8752 1.12109 17.9963 2.5 17.9963Z" fill="#87C7FF"/>']

